module.exports = __webpack_public_path__ + "img/9788958101499.37e77166.jpg";